import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

import StartLogin from './Start-login';
import ForgottenPasswordLogin from './Forgotten-password-login';
import ResetPasswordLogin from './Reset-password-login';
import localStorage from "../../Common/LocalStorage";

class FullLoginPage extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getFromStorage('lang') === undefined) {
            localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
        }
    }

    render() {
        return (
            <Switch>
                <Route
                    path={StaticRoutePaths.LOGIN}
                    exact
                    render={() => (
                        <StartLogin
                            {...this.props}
                            updateUsername={this.props.updateUsername}
                            loginHandler={this.props.loginHandler}
                            updatePassword={this.props.updatePassword}

                        />
                    )}
                />
                <Route path={StaticRoutePaths.LOGIN_FORGOTTEN_PASSWORD} exact render={() => (
                    <ForgottenPasswordLogin
                        {...this.props}
                        updateEmail={this.props.updateEmail}
                        sendMailHander={this.props.sendMailHander}
                    />
                )} />
                <Route path={StaticRoutePaths.LOGIN_RESET_PASSWORD} exact render={() => <ResetPasswordLogin />} />
            </Switch>
        );
    }
}

export default FullLoginPage;



// WEBPACK FOOTER //
// ./src/customModules/Login/components/Full-login.js